import { Wrench } from "lucide-react";

export const FitOutFixes = ({ fixes }) =>
  fixes?.length ? (
    <section className="mt-6 rounded-xl bg-[var(--bone-2)] p-5" data-testid="fit-out-fixes">
      <div className="eyebrow flex items-center gap-1.5"><Wrench size={13} /> What this renovation fixes</div>
      <ul className="mt-3 grid gap-2 text-sm">
        {fixes.map((f, i) => (
          <li key={i} className="leading-snug" data-testid={`fit-out-fix-${i}`}>
            {f.problem && <><span className="text-[var(--stone-dark)]">{f.problem}</span> → </>}<span className="font-medium">{f.correction}</span>
          </li>
        ))}
      </ul>
    </section>
  ) : null;
